var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgTag = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41.021 41.021",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3px",
    d: "M0,0H17.509l5.836,5.836-6.253,5.836H0Z",
    transform: "translate(11.673 23.869) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 1.668,
    cy: 1.668,
    r: 1.668,
    transform: "translate(25.013 15.008)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.172 9.172)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3px",
    y1: 6.67,
    transform: "translate(3.335)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3px",
    x2: 6.67,
    transform: "translate(0 3.335)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.2c39ab8f.svg";
export { ForwardRef as ReactComponent };